<div class="range-slider">
  <mat-slider
    class="range-slider__control"
    [min]="0"
    [max]="points().length - 1"
    [step]="1"
    discrete
    showTickMarks>
    <input
      matSliderStartThumb
      [value]="startIndex()"
      (valueChange)="startIndex.set($event)" />

    <input
      matSliderEndThumb
      [value]="endIndex()"
      (valueChange)="endIndex.set($event)" />
  </mat-slider>
</div>
